import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';
import { grayIconFill, titles } from '../../styles/colors';

export const s = StyleSheet.create({
	container: {
		alignItems: 'center',
		border: `1px dashed ${grayIconFill}`,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.lg,
	},
	icon: {
		color: grayIconFill,
	},
	title: {
		color: titles,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: 600,
		margin: 0,
	},
	subtitle: {
		color: grayIconFill,
		fontSize: THEME.typography.fontSizes.xs,
		margin: 0,
		textAlign: 'center',
	},
});
